<template>
  <div class="addBuyer">
    <div class="top"></div>
    <div class="content">
      <div class="title">基本信息
        <!-- （必填） -->
        </div>
      <div class="cont">
        <span>买家姓名</span>
        <input type="text" placeholder="请输入买家姓名" v-model="subData.name">
      </div>
      <div class="cont">
        <span>联系方式</span>
        <input type="number" placeholder="请输入买家电话" v-model="subData.mobile">
      </div>
      <div class="title">其他信息</div>
      <div class="cont">
        <span>车牌号码</span>
        <input type="text" placeholder="请输入车牌号" v-model="subData.car_no">
      </div>
      <div class="cont">
        <span>备注</span>
      </div>
      <div class="text">
        <div>
          <van-field
            v-model="subData.remark"
            rows="5"
            type="textarea"
            maxlength="120"
            placeholder="请输入备注信息"
            show-word-limit
          />
        </div>
      </div>
      <div class="bottom" @click="save">保存</div>
    </div>
  </div>
</template>

<script>
import { isEmpty, isMobile  } from "@/utils/validate";
import {buyer_update,buyer_detail_base,buyer_create} from "@/api/work/manage/buyer"

export default {
  name: 'addBuyer',
  data(){
    return {
      message:'',
      subData:{
        id:'',
        name:'',
        mobile:'',
        car_no:'',
        remark:'',
      },
      loading:true
    }
  },
  beforeRouteEnter (to, from, next) {
    if(to.query.id){
      to.meta.title = '编辑买家'
    }else{
      to.meta.title = '添加买家'
    }
    next()
  },
  created(){
    if(this.$route.query.id){
      this.subData.id = this.$route.query.id
      this.getData()
    }
  },
  mounted(){

  },
  methods:{
    // 获取数据
    getData(){
      buyer_detail_base({id:this.subData.id}).then(res=>{
        if(res.code == 200){
          this.subData.name = res.data.name
          this.subData.mobile = res.data.mobile
          this.subData.car_no = res.data.car_no
          this.subData.remark = res.data.remark
        }
      })
    },
    // 保存数据
    save(){
      if(!this.loading){
        return false
      }
      if(!this.subData.name){ this.$toast("请输入买家姓名！"); return false }
      if(!isMobile(this.subData.mobile)){ this.$toast("请输入正确的手机号码！"); return false }
      this.loading = false
      if(this.subData.id){
        buyer_update(this.subData).then(res=>{
          this.$toast.success(this.subData.id?"编辑成功！":"添加成功！")
          this.$router.go(-1)
        })
      }else{
        buyer_create(this.subData).then(res=>{
          this.$toast.success(this.subData.id?"编辑成功！":"添加成功！")
          this.$router.go(-1)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .addBuyer{
    .top{
      width: 100%;
      height: 3.6rem;
      background: url("../../../../assets/img/work/manage/buyer_bg.png") no-repeat center;
      background-size: 100% 100%;
    }
    .content{
      width: 6.5rem;
      margin: -1.8rem auto 0.78rem;
      background-color: #fff;
      padding: 0 0.3rem 0.3rem;
      border-radius: 0.16rem;
      overflow: hidden;
      .title{
        color: #727272;
        font-size: 0.24rem;
        margin-top: 0.44rem;
        margin-bottom: 0.09rem;
      }
      .cont{
        color: #343434;
        font-size: 0.28rem;
        border-bottom: #E8E8E8 solid 0.01rem;
        margin-top: 0.4rem;
        padding-bottom: 0.19rem;
        >span{
          display: inline-block;
          width: 2.24rem;
        }
      }
      .text{
        margin: 0.2rem auto 1.07rem;
        >div{
          width: 6.49rem;
          height: 3.26rem;
          border: 0.01rem #E4E4E4 solid;
        }
      }
      .bottom{
        width: 6.5rem;
        line-height: 1rem;
        background-color: #31b158;
        text-align: center;
        color: #fff;
        border-radius: 0.08rem;
      }
    }
  }
</style>